var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/leftChevron.18c9779f.png","uri@2x": __webpack_public_path__ + "static/media/leftChevron.18c9779f.png","uri@3x": __webpack_public_path__ + "static/media/leftChevron.565f7317.png",
    width: 31,
    height: 48
});